function resizeAmpIframe() {
  if (document.body.scrollHeight > 100) {
    window.parent.postMessage(
      {
        sentinel: 'amp',
        type: 'embed-size',
        height: document.body.scrollHeight,
      },
      '*',
    )
  }
}

export { resizeAmpIframe }
